/**
 * Settings section navigation context. Lets nested section components jump
 * to another section without lifting state up or re-opening the dialog.
 */

import { createContext, useContext } from 'react'

type SectionNav = (key: string) => void

const SectionNavContext = createContext<SectionNav>(() => {
  /** Default no-op so sections rendered outside the dialog don't crash. */
})

export const SectionNavProvider = SectionNavContext.Provider

export function useSectionNav(): SectionNav {
  return useContext(SectionNavContext)
}
